import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import * as d3 from 'd3';

@Component({
    selector: 'app-donut-chart',
    templateUrl: './donut-chart.component.html',
    styleUrls: ['./donut-chart.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DonutChartComponent implements OnInit, OnChanges {
  @ViewChild('chartContainer', { static: true }) chartContainer!: ElementRef;

  @Input() data: Array<any> = [];
  @Input() dataColumn: string = 'value';   // default for new design
  @Input() colorColumn: string = 'color';
  @Input() donutNewCenterText: any;
  @Input() donutWidth: number = 10;
  @Input() newDesign = false;

  private width!: number;
  private height!: number;

  constructor() {}

  ngOnInit(): void {
    // this.createChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'].currentValue != changes['data'].previousValue) {
      this.createChart()
    }
  }

  createChart() {
    if (!this.data || this.data.length === 0) return;

    const element = this.chartContainer.nativeElement;
    if (this.newDesign) {
      this.width = 80;
      this.height = 80;
    } else {
      this.width = element.offsetWidth || 100;
      this.height = element.offsetHeight || 100;
    }

    // Clear previous chart
    d3.select(element).selectAll('svg').remove();

    const svg = d3
      .select(element)
      .append('svg')
      .attr('width', this.width)
      .attr('height', this.height);

    const g = svg
      .append('g')
      .attr('transform', `translate(${this.width / 2},${this.height / 2})`);

    if (this.newDesign) {
      const radius = Math.min(this.width, this.height) / 2;

      const arc = d3.arc<any>()
        .innerRadius(radius * 0.75)  // thinner donut
        .outerRadius(radius * 0.9)   // inner ring radius
        .cornerRadius(0)
        .padAngle(0);

      const pie = d3.pie<any>()
          .sort(null)
          .padAngle(0) // 👈 Optional: spacing between slices
          .value((d: any) =>
            d[this.dataColumn] > 0 ? d[this.dataColumn] : 0
          );

      // Outer ring
      g.append('circle')
        .attr('r', radius)
        .attr('fill', '#f0f0f0')
        .attr('opacity', 1);

      // Donut arcs
      g.selectAll('path')
        .data(pie(this.data.filter(d => d[this.dataColumn] > 0)))
        .enter()
        .append('path')
        .attr('class',(d)=> 'arc'+ d.data.value)
        .attr('d', arc as any)
        .attr('fill', (d: any) => d.data[this.colorColumn])
        // .attr('stroke', '#fff')
        // .attr('stroke-width', 2);
      
      // Center percentage text
      const successObj = this.data.find((d) => d.showInchart);
      const percentage = successObj?.value ?? 0;


      g.append('text')
        .attr('text-anchor', 'middle')
        .attr('dy', '-0.2em')
        .style('font-size', '14px')
        .style('font-weight', 'bold')
        .style('fill', '#333')
        .text(`${percentage.toFixed(1)}%`);

      g.append('text')
        .attr('text-anchor', 'middle')
        .attr('dy', '1.2em')
        .style('font-size', '10px')
        .style('fill', '#999')
        .text(this.donutNewCenterText);
    }
    else {
      //  OLD DESIGN
      const pie = d3.pie<any>()
        .value((d: any) => d[this.dataColumn])
        .sort(null);

      let radius: number[] = [];
      let arc: any[] = [];
      let svgElement: any[] = [];
      let path: any[] = [];

      radius[0] = Math.min(this.width, this.height) / 2;

      for (let idx = 1; idx <= this.data.length; idx++) {
        radius[idx] = radius[idx - 1] - this.donutWidth;

        arc[idx] = d3.arc()
          .innerRadius(radius[idx] - this.donutWidth)
          .outerRadius(radius[idx]);

        svgElement[idx] = svg.append('g')
          .attr('transform', `translate(${this.width / 2},${this.height / 2})`);

        path[idx] = svgElement[idx]
          .selectAll('path')
          .data(pie(this.data[idx - 1]))
          .enter()
          .append('path')
          .attr('d', arc[idx])
          .attr('fill', (d: any, i: any) => {
            return this.data[idx - 1][i][this.colorColumn];
          });
      }
    }
  }
}
